// extracted by mini-css-extract-plugin
var _1 = "active__k9PxT";
var _2 = "header__dbC84";
var _3 = "nav-item__yb4M2";
export { _1 as "active", _2 as "header", _3 as "navItem" }
